var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('VText',{staticStyle:{"margin-bottom":"0.5rem"},attrs:{"component":"h2","variant":"h4"}},[_vm._v("\n    Recent profile\n  ")]),_vm._v(" "),(_vm.hasProfile)?_c('ProfileItem',{staticClass:"js-profile-item",attrs:{"profile":_vm.profile,"show-stats":""}}):_c('Skeleton',{attrs:{"width":"100%","height":"90px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }